<template>
  <b-modal
    body-class="confirm-modal-body"
    footer-class="confirm-modal-footer"
    header-class="confirm-modal-header"
    :id="String(id)"
    centered
  >
    <template #modal-header="{ close }">
      <subtitle>{{ title }}</subtitle>
      <button class="news-close-button" @click="close()" />
    </template>

    <main-text>{{ content }}</main-text>

    <template #modal-footer="{ cancel }">
      <main-button
        color="danger"
        :loading="loading"
        class="confirm-modal-footer-button"
        @click="$emit('onSubmitClick')"
      >
        Удалить
      </main-button>
      <main-button class="confirm-modal-footer-button" color="link" @click="cancel()">Отмена</main-button>
    </template>
  </b-modal>
</template>

<script>
import Text from "../ui/Text.vue";
import Subtitle from "../ui/Subtitle.vue";
import MainButton from "../ui/MainButton.vue";

export default {
  props: {
    title: String,
    content: String,
    loading: Boolean,
    id: {
      type: [String, Number],
      require: true,
    },
  },
  components: { "main-text": Text, Subtitle, MainButton },
};
</script>

<style>
.confirm-modal-header {
  padding: 24px 24px 0;
  border: none;
}

.confirm-modal-body {
  padding: 32px 24px 0;
}

.confirm-modal-footer {
  margin-top: 32px;
  padding: 16px 24px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: var(--background-color);
}

.confirm-modal-footer-button {
  margin: 0 16px 0 0;
}
</style>
